export function StarsBg({ count = 60 }) {
  // Wygeneruj losowe gwiazdy
  const stars = Array.from({ length: count }).map((_, i) => {
    const size = Math.random() * 2 + 1; // 1px–3px
    const left = Math.random() * 100;   // procentowo
    const delay = Math.random() * 8;    // sekundy
    const duration = 6 + Math.random() * 12; // sekundy
    return (
      <div
        key={i}
        className="star"
        style={{
          width: size,
          height: size,
          left: `${left}vw`,
          top: `${-Math.random() * 20}vh`,
          animationDelay: `${delay}s`,
          animationDuration: `${duration}s`,
        }}
      />
    );
  });
  return <div className="stars-bg">{stars}</div>;
}

